<template>
    <!-- 업로드 영역 -->
    <!-- 
    <div class="row px-4">
        <div class="col-12" v-if="this.$store.state.login.userType == '관리자'">
            <div class="card">

                <label for="dentalForm" class="m-0">
                    <div class="card-body text-center onmaum-text-default-hover">
                        <i class="far fa-plus-square onmaum-font-3vw"></i>
                        <input type="file" id="dentalForm" multiple="false" @change="dentalFormChanged">
                    </div>
                </label>

            </div>
        </div>

        <div class="col-3 mt-2">

        </div>
        <div class="col-3 mt-2">

        </div>
        <div class="col-3 mt-2">

        </div>
        <div class="col-3 mt-2">
            
        </div>
    </div> -->

    <!-- 목록 -->
    <div class="row px-4">
        <div class="col-12">
            <div class="card">
                <div class="card-header pb-0">
                    <div class="row">
                        <div class="col-md-4">
                            <i class="fas fa-file-alt text-secondary text-sm opacity-10"></i><span class="mb-0" style="font-size: 1rem; line-height: 1.625; font-weight: 600; margin-top: 0; color: #344767"> 치과청구확인서</span>
                        </div>
                        <div class="col-md-4">

                        </div>
                        <div class="col-md-2">
                            <input type="text" class="form-control" placeholder="검색어 입력" @keydown.enter="search($event.target.value)"/>
                        </div>
                        <div class="col-md-2 text-center">
                            <div class="filebox" v-if="this.$store.state.login.userType == '관리자'">
                                <label for="dentalForm">파일추가</label>
                                <input type="file" id="dentalForm" multiple="true" @change="dentalFormChanged">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-body px-0 pt-0 pb-2">
                    <div class="table-responsive p-0 onmaum-overflow-y onmaum-overflow-type02 onmaum-h-70-v">
                        <table class="table table-striped text-center align-items-center mb-0">
                            <thead>
                                <tr>
                                    <th class="text-secondary text-sm font-weight-bolder opacity-7" scope="col" width="5%" >번호</th>
                                    <th class="text-secondary text-sm font-weight-bolder opacity-7" scope="col" width="15%" >구분</th>
                                    <th class="text-secondary text-sm font-weight-bolder opacity-7" scope="col" width="60%" >제목</th>
                                    <th class="text-secondary text-sm font-weight-bolder opacity-7" scope="col" width="20%" >버튼</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(form, i) in dentalFormInfo" :key="i">
                                    <td class="align-middle text-center text-sm">
                                        <p class="text-sm font-weight-bold mb-0">{{ i + 1 }}</p>
                                    </td>
                                    <td class="align-middle text-center text-sm">
                                        <span class="badge w-100 onmaum-badge-rescue" v-if="decodeURIComponent(form.file_name).indexOf('청구') > -1 && decodeURIComponent(form.file_name).indexOf('확인') > -1">청구서/확인서</span>
                                        <span class="badge w-100 onmaum-badge-contract" v-else-if="decodeURIComponent(form.file_name).indexOf('청구') > -1">청구서</span>
                                        <span class="badge w-100 onmaum-badge-sns" v-else-if="decodeURIComponent(form.file_name).indexOf('확인') > -1">확인서</span>
                                        <span class="badge w-100 onmaum-badge-hondi" v-else>기타</span>
                                    </td>
                                    <td class="align-middle text-center text-sm">
                                        <p class="text-sm font-weight-bold mb-0">{{ decodeURIComponent(form.file_name) }}</p>
                                    </td>
                                    <td class="align-middle text-center text-sm w-100">
                                        <button class="btn btn-onmaum btn-sm mx-2" @click="download(form.file_info.key)"><i class="fas fa-download onmaum-font-1rem"></i></button>
                                        <button class="btn btn-danger btn-sm mx-2" v-if="this.$store.state.login.userType == '관리자'" @click="deleteFile(form._id, form.file_info.key)"><i class="fas fa-trash-alt onmaum-font-1rem"></i></button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="col-md-4 col-12 mt-2" v-for="(form, i) in dentalFormInfo" :key="i">
            <div class="card">
                <div class="card-header" :class="
                    decodeURIComponent(form.file_name).indexOf('청구') > -1 && decodeURIComponent(form.file_name).indexOf('확인') > -1 ? 'onmaum-badge-rescue' 
                    : decodeURIComponent(form.file_name).indexOf('청구') > -1 ? 'onmaum-badge-contract'
                    : decodeURIComponent(form.file_name).indexOf('확인') > -1 ? 'onmaum-badge-sns'
                    : 'onmaum-badge-hondi'
                    ">{{ decodeURIComponent(form.file_name) }}</div>
                <div class="card-body">
                    <div class="row" v-if="this.$store.state.login.userType == '관리자'">
                        <div class="col-6">
                            <button class="btn btn-onmaum btn-sm w-100" @click="download(form.file_info.key)"><i class="fas fa-save onmaum-font-1rem"></i></button>
                        </div>
                        <div class="col-6">
                            <button class="btn btn-danger btn-sm w-100" @click="deleteFile(form._id, form.file_info.key)"><i class="fas fa-trash-alt onmaum-font-1rem"></i></button>
                        </div>
                    </div>
                    <div class="row" v-else>
                        <div class="col-12">
                            <button class="btn btn-onmaum btn-sm w-100" @click="download(form.file_info.key)"><i class="fas fa-save onmaum-font-1rem"></i></button>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
    </div>
</template>

<script>
import $ from 'jquery'

export default {
    name:'DentalForm',

    data() {
        return{
            
        }
    },

    methods: {
        dentalFormChanged(){
            let fileUploader = $('#dentalForm').get(0);
            let file = fileUploader.files;

            this.$store.dispatch('uploadDentalForm', {dentalForm: file});
        },

        //첨부파일 삭제
        deleteFile(id, key){
            this.$store.commit('setAlert', {
                                          'alertStatus': 'confirm'
                                          ,'alertTitle': '치과청구확인서'
                                          ,'alertContent': `선택한 치과청구확인서를 삭제하시겠습니까?|**삭제한 정보는 복구할 수 없으므로 신중히 삭제하시기 바랍니다.}`
                                          ,'callback': 'deleteDentalForm'
                                          ,'parameter': {id: id, key: key}
                                      }
                          );
        },

        //첨부파일 다운로드
        download(key){
            this.$store.dispatch('downloadDentalForm', `${key}`);
        },

        //치과청구확인서 검색
        search(text) {
            this.$store.state.common.dentalFormSearchText = text;
        }

    },

    computed: {
        dentalFormInfo(){
            return this.$store.getters.getDentalFormInfo;
        }
    },

    mounted(){
        this.$store.dispatch('getDentalForm');
    }


}
</script>

<style>
#dentalForm {
    position: absolute;
    width: 0;
    height: 0;
    padding: 0;
    overflow: hidden;
    border: 0;
}
</style>